module.exports = __webpack_public_path__ + "static/media/take-notes.b42c44b4.md";